import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const updateCommandLine = async ({ testStepId, testCaseId, cmdfile }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateBatchFile&companyid=${user.companyid}&testCaseId=${testCaseId}&teststepid=${testStepId}&name=${cmdfile}`,
    {
      teststepid: testStepId,
      testCaseId: testCaseId,
      script: 'selectCmdFile',
      cmdfile: cmdfile,
    }
  );

  return response.data;
};

const useCommandLineUpdateQuery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCommandLine,
    onSuccess: () => {
      queryClient.invalidateQueries(["commandLineFiles", "testCaseResults"]);
    },
    onError: (error) => {
      console.log("Error updating command line file", error.message);
    },
  });
};

export default useCommandLineUpdateQuery; 